import * as angular from "angular";
import "./ConfirmDeleteDialog.html";
export class ConfirmDeleteAnnotationDialogController {
  public static $inject = ["$uibModalInstance"];
  constructor(
    private $uibModalInstance: angular.ui.bootstrap.IModalServiceInstance
  ) {}

  public ok = () => {
    this.$uibModalInstance.close();
  };

  public cancel = () => {
    this.$uibModalInstance.dismiss();
  };
}

angular
  .module("PortalApp")
  .controller(
    "Rhinestone.ConfirmDeleteCollectionDialogController",
    ConfirmDeleteAnnotationDialogController
  );
